import React from "react";
import { Link, useLocation } from "react-router-dom";

function Footer() {
  const { pathname } = useLocation();
  if (pathname === "/contact") {
    return null;
  }

  return (
    <footer className="relative bg-black text-white font-chivo overflow-hidden border-t border-white/5">
      {/* Glow accents */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-brand-600/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-brand-900/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        {/* Top CTA strip */}
        <div className="rounded-3xl bg-gradient-to-br from-brand-600 to-brand-900 p-8 md:p-12 mb-16 overflow-hidden relative">
          <div className="absolute inset-0 bg-grid-pattern bg-[size:30px_30px] opacity-20"></div>
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl md:text-4xl font-black font-chivo tracking-tight">
                Need your car fixed today?
              </h3>
              <p className="text-white/80 mt-2 font-montserrat">
                25+ years of trusted service in New York City.
              </p>
            </div>
            <a href="tel:+13475820864">
              <button className="rounded-full px-8 py-4 bg-white text-brand-700 font-bold hover:bg-zinc-100 hover:scale-105 transition-all shadow-xl">
                <span className="flex items-center gap-3">
                  <i className="fa-solid fa-phone"></i>
                  Call Now
                </span>
              </button>
            </a>
          </div>
        </div>

        {/* Info grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="inline-block px-3 py-1.5 rounded-lg bg-gradient-to-r from-brand-500 to-brand-700 text-xs font-bold uppercase tracking-wider mb-5">
              Bini AutoRepair
            </div>
            <p className="text-zinc-400 text-sm font-montserrat leading-relaxed">
              Your trusted auto repair shop in New York City with over 25 years
              of experience.
            </p>
          </div>

          {/* Location */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-brand-400 font-bold mb-5">
              Location
            </h4>
            <a
              href="https://www.google.com/maps/place/BiniAutoRepairINC/@40.9515721,-73.8751458,15z/data=!4m2!3m1!1s0x0:0x58aeec725b7b64cb?sa=X&ved=1t:2428&ictx=111"
              rel="noreferrer"
              target="_blank"
              className="flex items-start gap-3 text-zinc-300 hover:text-white transition-colors group"
            >
              <i className="fa-solid fa-location-dot text-brand-500 mt-1 group-hover:scale-110 transition-transform"></i>
              <div className="flex flex-col font-montserrat text-sm">
                <span>10 Eastman Pl</span>
                <span>Yonkers, NY 10701</span>
              </div>
            </a>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-brand-400 font-bold mb-5">
              Contact
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="tel:+13475820864"
                className="flex items-center gap-3 text-zinc-300 hover:text-white transition-colors group text-sm"
              >
                <i className="fa-solid fa-phone text-brand-500 group-hover:scale-110 transition-transform"></i>
                <span className="font-montserrat">+13475820864</span>
              </a>
              <a
                href="mailto:biniautorepairinc@gmail.com"
                className="flex items-center gap-3 text-zinc-300 hover:text-white transition-colors group text-sm"
              >
                <i className="fa-solid fa-envelope text-brand-500 group-hover:scale-110 transition-transform"></i>
                <span className="font-montserrat break-all">
                  biniautorepairinc@gmail.com
                </span>
              </a>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-brand-400 font-bold mb-5">
              Social Media
            </h4>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/biniautorepairinc/"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-xl border border-white/10 bg-white/5 text-zinc-300 hover:bg-gradient-to-br hover:from-brand-500 hover:to-brand-800 hover:text-white hover:border-transparent hover:scale-110 transition-all"
              >
                <i className="fa-brands fa-instagram fa-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@biniautorepair"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-xl border border-white/10 bg-white/5 text-zinc-300 hover:bg-gradient-to-br hover:from-brand-500 hover:to-brand-800 hover:text-white hover:border-transparent hover:scale-110 transition-all"
              >
                <i className="fa-brands fa-tiktok fa-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-zinc-500 text-sm font-montserrat">
            Copyrights {new Date().getFullYear()} Bini AutoRepair INC. All Rights Reserved.
          </span>
          <div className="flex items-center gap-6 text-xs text-zinc-500 uppercase tracking-wider">
            <Link to="/" className="hover:text-white transition-colors">
              Home
            </Link>
            <Link to="/services" className="hover:text-white transition-colors">
              Services
            </Link>
            <Link to="/aboutus" className="hover:text-white transition-colors">
              About
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
